import { privateApi } from "@core/libs/axios/apiInstances"
import { handleResponse } from "@core/libs/axios/serviceHandler"
import { SubscriptionSchema, SubscriptionMemberSchema } from "../types"
import type { TSubscription, TSubscriptionMember } from "../types"
import { createLogger } from "@core/utils/logger"

const log = createLogger("subscription")

// ─── Mappers (private) ────────────────────────────────────────────────────────
function mapSubscription(dto: unknown): TSubscription {
  return log.parseWith(SubscriptionSchema, dto, "getSubscription")
}

function mapSubscriptionMember(dto: unknown): TSubscriptionMember {
  return log.parseWith(SubscriptionMemberSchema, dto, "getSubscriptionMember")
}

// ─── Services ─────────────────────────────────────────────────────────────────
export async function getSubscription(
  workspaceId: string,
  signal?: AbortSignal,
): Promise<TSubscription> {
  const data = await handleResponse<TSubscription>(
    privateApi.get<TSubscription>(`/workspace/${workspaceId}/subscription`, { signal }),
  )
  return mapSubscription(data)
}

export async function getSubscriptionMember(
  workspaceId: string,
  signal?: AbortSignal,
): Promise<TSubscriptionMember> {
  const data = await handleResponse<TSubscriptionMember>(
    privateApi.get<TSubscriptionMember>(
      `/projects/workspace/${workspaceId}/subscription`,
      { signal },
    ),
  )
  return mapSubscriptionMember(data)
}
